import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  tableCellClasses,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { AiOutlineMinus } from 'react-icons/ai';
import { MdOutlineAdd } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import { NOT_AVAILABLE } from '../Global/Constants';
import Loader from '../Global/Loader';
import { CommonApiforJourney } from '../services/RecommendationApi';
import CallCenterService from '../services/CallCenterService';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { GetAllAssignableStatuses, UpdateStatus } = CallCenterService;

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));

function UpdateDisburse() {
  const navigate = useNavigate();
  const [openAppointment, setOpenAppointment] = useState({ status: false, indexVal: null });
  const [openFollowUp, setOpenFollowUp] = useState({ status: false, indexVal: null });
  const [updateStatusList, setUpdateStatusList] = useState([]);
  const [selectedItemList, setSelectedItemList] = useState([]);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [openLoader, setOpenLoader] = useState(false);

  const { LoginData } = useLoginSelector();

  const handleStatus = (e, index) => {
    const selectedValue = e.target.value;
    if (JSON.parse(selectedValue).stageStatusName.toLowerCase() === 'disbursed') {
      setOpenFollowUp({ status: true, indexVal: index });
    } else if (JSON.parse(selectedValue).stageStatusName.toLowerCase() === 'encashment') {
      setOpenAppointment({ status: true, indexVal: index });
    }
    const prevArray = selectedItemList;
    prevArray[index].status = selectedValue;
    setSelectedItemList([...prevArray]);
  };

  const handleFollowUpSubmit = (e, indexVal) => {
    if (selectedItemList[indexVal].disbursementDisburseDetailsModel.disbursedAmount === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter disbursed amount');
      return;
    } else if (
      selectedItemList[indexVal].disbursementDisburseDetailsModel
        .disbursementDisburseDocumentsDetailsModelList.length < 1
    ) {
      setDialogOpen(true);
      setValidationMsg('Please upload supporting document');
      return;
    }
    const prevArray = selectedItemList;
    prevArray[indexVal].disbursementDisburseDetailsModel.isSubmitClicked = true;
    setSelectedItemList([...prevArray]);
    setOpenFollowUp({ status: false, indexVal: null });
  };

  const handleAppointmentSubmit = (e, indexVal) => {
    let loanTypeValidate = true;
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);
    if (
      !selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel?.remarks &&
      selectedItemList[indexVal].encashmentDisburseDetailsModel.encashmentAmount === ''
    ) {
      setDialogOpen(true);
      setValidationMsg('Please enter encashment amount');
      loanTypeValidate = false;
    } else if (
      selectedItemList[indexVal].encashmentDisburseDetailsModel
        .encashmentDisburseDocumentsDetailsModels.length < 1
    ) {
      setDialogOpen(true);
      setValidationMsg('Please upload supporting document');
      loanTypeValidate = false;
    } else if (
      selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel?.remarks
    ) {
      selectedItemList[
        openAppointment.indexVal
      ]?.encashmentDisburseDetailsModel?.partialEncashmentDisburseDetailsModelList?.every(
        (itemValidate) => {
          if (
            itemValidate.partialEncashmentDate === null ||
            itemValidate.partialEncashmentDate === ''
          ) {
            setDialogOpen(true);
            setValidationMsg('Please enter date');
            loanTypeValidate = false;
          } else if (itemValidate.partialAmount === null || itemValidate.partialAmount === '') {
            setDialogOpen(true);
            setValidationMsg('Please enter encashment partial amount');
            loanTypeValidate = false;
          } else if (itemValidate.remarks === null || itemValidate.remarks === '') {
            setDialogOpen(true);
            setValidationMsg('Please enter remarks');
            loanTypeValidate = false;
          } else if (currentDate > new Date(itemValidate.partialEncashmentDate)) {
            setDialogOpen(true);
            setValidationMsg('Please enter valid encashment date');
            loanTypeValidate = false;
          }
          return loanTypeValidate;
        }
      );
    }

    if (loanTypeValidate === true) {
      const prevArray = selectedItemList;
      prevArray[indexVal].encashmentDisburseDetailsModel.isSubmitClicked = true;
      setSelectedItemList([...prevArray]);
      setOpenAppointment({ status: false, indexVal: null });
    }
  };

  const handleFollowUpCloseIcon = (e) => {
    const prevArray = selectedItemList;
    if (
      prevArray[openFollowUp.indexVal]?.disbursementDisburseDetailsModel?.disbursedAmount !== '' &&
      prevArray[openFollowUp.indexVal]?.disbursementDisburseDetailsModel?.isSubmitClicked
    ) {
      setOpenFollowUp({ status: false, indexVal: null });
    } else {
      prevArray[openFollowUp.indexVal].status = ' ';
      setSelectedItemList([...prevArray]);
      setOpenFollowUp({ status: false, indexVal: null });
    }
  };

  const handleAppointmentCloseIcon = (e) => {
    const prevArray = selectedItemList;
    if (
      prevArray[openAppointment.indexVal].encashmentDisburseDetailsModel.encashmentAmount !== '' &&
      prevArray[openAppointment.indexVal].encashmentDisburseDetailsModel.isSubmitClicked
    ) {
      setOpenAppointment({ status: false, indexVal: null });
    } else {
      prevArray[openAppointment.indexVal].status = ' ';
      setSelectedItemList([...prevArray]);
      setOpenAppointment({ status: false, indexVal: null });
    }
  };

  const handleUpdate = async (e) => {
    const objArray = [];
    selectedItemList.forEach((item, index) => {
      if (
        item.status !== ' ' &&
        JSON.parse(item.status).stageStatusName.toLowerCase() === 'disbursed'
      ) {
        const obj = {
          leadId: item.leadId,
          stageCode: 'DISBURSE',
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          disbursementDisburseDetailsModel: {
            disbursedAmount: item.disbursementDisburseDetailsModel.disbursedAmount,
            disbursementDisburseDocumentsDetailsModelList:
              item.disbursementDisburseDetailsModel.disbursementDisburseDocumentsDetailsModelList
          },
          comments: item.comments,
          applicationId: item.applicationId
        };
        objArray.push(obj);
      } else if (
        item.status !== ' ' &&
        JSON.parse(item.status).stageStatusName.toLowerCase() === 'encashment'
      ) {
        const encashment = item?.encashmentDisburseDetailsModel || {};

        const obj = {
          leadId: item.leadId,
          stageCode: 'DISBURSE',
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          encashmentDisburseDetailsModel: {
            encashmentAmount: encashment.encashmentAmount ?? null,
            encashmentDisburseDocumentsDetailsModels:
              encashment.encashmentDisburseDocumentsDetailsModels ?? [],
            partialEncashmentDisburseDetailsModelList: !encashment.encashmentAmount
              ? encashment.partialEncashmentDisburseDetailsModelList ?? []
              : []
          },
          comments: item.comments,
          applicationId: item.applicationId
        };
        objArray.push(obj);
      } else if (item.status !== ' ') {
        const obj = {
          leadId: item.leadId,
          stageCode: 'DISBURSE',
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          comments: item.comments,
          applicationId: item.applicationId
        };
        objArray.push(obj);
      }
    });

    if (objArray.length === selectedItemList.length) {
      const UpdateStatusApi = await UpdateStatus(objArray, LoginData?.jwt);
      if (UpdateStatusApi.status === 'success') {
        setSelectedItemList([]);
        navigate('/disburse');
      } else {
        setOpenApiError(true);
        setErrorMessage('Something went wrong !');
      }
    } else {
      setDialogOpen(true);
      setValidationMsg('Please select status');
    }
  };

  useEffect(async () => {
    const localSelectedItem = JSON.parse(localStorage.getItem('selectedItem'));
    const stageCode = 'DISBURSE';
    const authToken = LoginData?.jwt;

    const GetAllAssignableStatusesApi = await GetAllAssignableStatuses(stageCode, authToken);
    if (GetAllAssignableStatusesApi.status === 'success') {
      GetAllAssignableStatusesApi.data.forEach((item) => {
        item.leadStatus = true;
        localSelectedItem.forEach((listItem) => {
          if (
            listItem.status.toLowerCase() !== 'disbursed' &&
            item.stageStatusName.toLowerCase() === 'encashment'
          ) {
            item.leadStatus = false;
          } else if (
            listItem.status.toLowerCase() === 'encashment' &&
            item.stageStatusName.toLowerCase() === 'disbursed'
          ) {
            item.leadStatus = false;
          } else if (
            listItem.status.toLowerCase() === 'disbursed' &&
            item.stageStatusName.toLowerCase() === 'disbursed'
          ) {
            item.leadStatus = false;
          }
        });
      });

      setUpdateStatusList(GetAllAssignableStatusesApi.data);
    }

    if (localSelectedItem && localSelectedItem.length > 0) {
      localSelectedItem.forEach((item, index) => {
        item.status = ' ';
        item.comments = '';
        item.disbursementDisburseDetailsModel = {
          disbursedAmount: '',
          disbursementDisburseDocumentsDetailsModelList: []
        };
        item.encashmentDisburseDetailsModel = {
          encashmentAmount: '',
          encashmentDisburseDocumentsDetailsModels: [],
          partialEncashmentDisburseDetailsModelList: [
            {
              partialAmount: '',
              partialEncashmentDate: '',
              remarks: ''
            }
          ],
          remarks: false
        };
      });
      setSelectedItemList(localSelectedItem);
    } else {
      setSelectedItemList([]);
    }
  }, []);

  useEffect(() => {
    setOpenLoader(true);
    if (selectedItemList.length > 0) {
      setOpenLoader(false);
    }
  }, [selectedItemList]);

  const uploadFileApiFire = async (type, condition, no, index) => {
    const companyIdObj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    let methodName = '';
    let endapiPath = '';
    const token = LoginData?.jwt;
    if (type === 'fileUpload') {
      const formData = new FormData();
      formData.append('companyId', companyIdObj.companyId);
      formData.append('userId', companyIdObj.userId);
      formData.append('applicationId ', index);
      formData.append('file ', condition);
      methodName = 'POST';
      endapiPath = 'file/uploadFile';
      uploadFileApiFireResponse(
        type,
        methodName,
        endapiPath,
        formData,
        token,
        'formdata',
        condition,
        no
      );
    }
  };

  const uploadFileApiFireResponse = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData,
    condition,
    no
  ) => {
    setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      setOpenLoader(false);
      if (type === 'fileUpload') {
        const prevArray = selectedItemList;
        if (no === 'disbursed') {
          prevArray[
            openFollowUp.indexVal
          ].disbursementDisburseDetailsModel.disbursementDisburseDocumentsDetailsModelList.push({
            fileName: condition.name,
            savedName: responseData.data.fileDetails.name
          });
        } else {
          prevArray[
            openAppointment.indexVal
          ].encashmentDisburseDetailsModel.encashmentDisburseDocumentsDetailsModels.push({
            fileName: condition.name,
            savedName: responseData.data.fileDetails.name
          });
        }
        setSelectedItemList([...prevArray]);
      }
    } else {
      setOpenLoader(false);
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  return (
    <Page title="Partner Management System || Disburse">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="Update Disburse Status" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Box className="tableBox" mb={3}>
            <TableContainer sx={{ minWidth: 800, overflow: 'auto', background: 'white' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Lead ID</StyledTableCell>
                    <StyledTableCell align="">Lead Name</StyledTableCell>
                    <StyledTableCell align="">Status</StyledTableCell>
                    <StyledTableCell align="">Comments</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedItemList.length > 0
                    ? selectedItemList?.map((item, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell align="">
                            {item.leadId ? item.leadId : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="">
                            {item.leadName ? item.leadName : `${NOT_AVAILABLE}`}
                          </StyledTableCell>
                          <StyledTableCell align="">
                            <Select
                              fullWidth
                              inputProps={{
                                className: `textInput textInputTable customSelectBox dissabledMenu${item.status}`
                              }}
                              value={item.status}
                              onChange={(e) => {
                                handleStatus(e, index);
                              }}
                              sx={{ minWidth: '200px' }}
                            >
                              <MenuItem value=" " disabled>
                                Select Status
                              </MenuItem>

                              {updateStatusList.length > 0
                                ? updateStatusList.map((item1, index1) => (
                                    <MenuItem
                                      disabled={!item1.leadStatus}
                                      value={JSON.stringify(item1)}
                                      key={index1}
                                    >
                                      {item1.stageStatusName}
                                    </MenuItem>
                                  ))
                                : ''}
                            </Select>
                          </StyledTableCell>
                          <StyledTableCell align="">
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'textInput textInputTable'
                              }}
                              placeholder="Write Your Comments"
                              sx={{ minWidth: '200px' }}
                              value={item.comments}
                              onChange={(e) => {
                                const prevArray = selectedItemList;
                                prevArray[index].comments = e.target.value;
                                setSelectedItemList([...prevArray]);
                              }}
                            />
                          </StyledTableCell>
                        </StyledTableRow>
                      ))
                    : ''}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box className="" textAlign="right">
            <Button variant="contained" className="mainBtn" onClick={(e) => handleUpdate(e)}>
              Update
            </Button>
          </Box>

          <Dialog
            className="PopupBox"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            open={openFollowUp.status}
            fullWidth
            onClose={(e) => {
              handleFollowUpCloseIcon(e);
            }}
          >
            <DialogTitle className="popupTitle">
              <Typography variant="h6">Disbursed</Typography>
              <IconButton
                onClick={(e) => {
                  handleFollowUpCloseIcon(e);
                }}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Box mb={2}>
                <FormControl required fullWidth className="formGroup">
                  <Typography variant="body1" className="formLabel">
                    Disbursed Amount
                  </Typography>
                  <TextField
                    inputProps={{ className: 'textInput' }}
                    fullWidth
                    placeholder="Disbursed Amount"
                    value={
                      selectedItemList[openFollowUp.indexVal]?.disbursementDisburseDetailsModel
                        ?.disbursedAmount
                    }
                    type="number"
                    onChange={(e) => {
                      const prevArray = selectedItemList;
                      if (true) {
                        prevArray[
                          openFollowUp.indexVal
                        ].disbursementDisburseDetailsModel.disbursedAmount = e.target.value;
                      } else {
                        prevArray[
                          openFollowUp.indexVal
                        ].disbursementDisburseDetailsModel.disbursedAmount = '';
                      }
                      setSelectedItemList([...prevArray]);
                    }}
                  />
                </FormControl>
              </Box>
              <Button
                variant="contained"
                className="mainBtn mainBtnSec mainBtnOther mb-2"
                component="label"
              >
                Upload supporting document
                <input
                  hidden
                  accept="image/png, image/gif, image/jpeg, image/jpg"
                  type="file"
                  onChange={(e) => {
                    const fileData = e.target.files[0];
                    if (fileData !== undefined) {
                      uploadFileApiFire(
                        'fileUpload',
                        fileData,
                        'disbursed',
                        selectedItemList[openFollowUp.indexVal].applicationId
                      );
                    }
                  }}
                />
              </Button>
              <Box className="">
                <Typography variant="body2" mb={0.5}>
                  <strong>List of document uploaded </strong>
                </Typography>
                {selectedItemList[openFollowUp.indexVal]?.disbursementDisburseDetailsModel
                  ?.disbursementDisburseDocumentsDetailsModelList.length > 0 ? (
                  selectedItemList[
                    openFollowUp.indexVal
                  ]?.disbursementDisburseDetailsModel?.disbursementDisburseDocumentsDetailsModelList.map(
                    (fileTtem, fileTtemIndex) => (
                      <Typography key={fileTtemIndex} variant="body2">
                        <span style={{ width: '100%', float: 'left' }}>
                          <span style={{ float: 'left', paddingRight: '5px' }}>
                            {fileTtem.fileName}
                          </span>{' '}
                          <CancelIcon
                            style={{
                              marginTop: '3px',
                              float: 'left',
                              fontSize: '15px',
                              cursor: 'pointer'
                            }}
                            onClick={() => {
                              const prevArray = selectedItemList;
                              prevArray[
                                openFollowUp.indexVal
                              ].disbursementDisburseDetailsModel.disbursementDisburseDocumentsDetailsModelList.splice(
                                fileTtemIndex,
                                1
                              );
                              setSelectedItemList([...prevArray]);
                            }}
                          />
                        </span>
                      </Typography>
                    )
                  )
                ) : (
                  <Typography variant="body2">No Document Uploaded</Typography>
                )}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  handleFollowUpSubmit(e, openFollowUp.indexVal);
                }}
                variant="contained"
                className="mainBtn"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            className="PopupBox"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            open={openAppointment.status}
            fullWidth
            onClose={(e) => {
              handleAppointmentCloseIcon(e);
            }}
          >
            <DialogTitle className="popupTitle">
              <Typography variant="h6">Encashment</Typography>
              <IconButton
                onClick={(e) => {
                  handleAppointmentCloseIcon(e);
                }}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              {!selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                ?.remarks && (
                <Box mb={2}>
                  <FormControl required fullWidth className="formGroup">
                    <Typography variant="body1" className="formLabel">
                      Encashment Amount
                    </Typography>
                    <TextField
                      inputProps={{ className: 'textInput' }}
                      fullWidth
                      placeholder="Encashment Amount"
                      value={
                        selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                          .encashmentAmount
                      }
                      onChange={(e) => {
                        const prevArray = selectedItemList;
                        if (/^\d+$/.test(e.target.value.trim())) {
                          prevArray[
                            openAppointment.indexVal
                          ].encashmentDisburseDetailsModel.encashmentAmount = e.target.value;
                        } else {
                          prevArray[
                            openAppointment.indexVal
                          ].encashmentDisburseDetailsModel.encashmentAmount = '';
                        }
                        setSelectedItemList([...prevArray]);
                      }}
                    />
                  </FormControl>
                </Box>
              )}
              <Box mb={2}>
                <FormControlLabel
                  checked={
                    selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                      ?.remarks
                  }
                  onChange={(e) => {
                    const prevArray = selectedItemList;
                    prevArray[openAppointment.indexVal].encashmentDisburseDetailsModel.remarks =
                      !prevArray[openAppointment.indexVal].encashmentDisburseDetailsModel.remarks;
                    prevArray[
                      openAppointment.indexVal
                    ].encashmentDisburseDetailsModel.encashmentAmount = '';
                    setSelectedItemList([...prevArray]);
                  }}
                  control={<Checkbox size="small" sx={{ padding: '0 10px' }} disableRipple />}
                  label={<Typography variant="body2">Partial Encashment Allowed</Typography>}
                />
              </Box>
              {selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel?.remarks
                ? selectedItemList[
                    openAppointment.indexVal
                  ]?.encashmentDisburseDetailsModel?.partialEncashmentDisburseDetailsModelList?.map(
                    (addItem, addItemIndex) => (
                      <Grid key={addItemIndex} container spacing={2} mb={2} alignItems="end">
                        <Grid item xs>
                          <Box className="">
                            <TextField
                              fullWidth
                              type="date"
                              inputProps={{
                                className: 'textInput'
                              }}
                              value={addItem.partialEncashmentDate}
                              onChange={(e) => {
                                const prevArray = selectedItemList;
                                prevArray[
                                  openAppointment.indexVal
                                ].encashmentDisburseDetailsModel.partialEncashmentDisburseDetailsModelList[
                                  addItemIndex
                                ].partialEncashmentDate = e.target.value;
                                setSelectedItemList([...prevArray]);
                              }}
                              placeholder="Select Date"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs>
                          <Box className="">
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'textInput'
                              }}
                              value={addItem.partialAmount}
                              onChange={(e) => {
                                const prevArray = selectedItemList;
                                if (/^\d+$/.test(e.target.value.trim())) {
                                  prevArray[
                                    openAppointment.indexVal
                                  ].encashmentDisburseDetailsModel.partialEncashmentDisburseDetailsModelList[
                                    addItemIndex
                                  ].partialAmount = e.target.value;
                                } else {
                                  prevArray[
                                    openAppointment.indexVal
                                  ].encashmentDisburseDetailsModel.partialEncashmentDisburseDetailsModelList[
                                    addItemIndex
                                  ].partialAmount = '';
                                }

                                setSelectedItemList([...prevArray]);
                              }}
                              placeholder="Type Amount"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs>
                          <Box className="">
                            <TextField
                              fullWidth
                              inputProps={{
                                className: 'textInput'
                              }}
                              value={addItem.remarks}
                              onChange={(e) => {
                                const prevArray = selectedItemList;
                                prevArray[
                                  openAppointment.indexVal
                                ].encashmentDisburseDetailsModel.partialEncashmentDisburseDetailsModelList[
                                  addItemIndex
                                ].remarks = e.target.value;
                                setSelectedItemList([...prevArray]);
                              }}
                              placeholder="Type Remarks"
                            />
                          </Box>
                        </Grid>
                        <Grid item xs="auto">
                          {addItemIndex === 0 ? (
                            <Tooltip
                              title="Add"
                              onClick={() => {
                                const prevArray = selectedItemList;
                                prevArray[
                                  openAppointment.indexVal
                                ]?.encashmentDisburseDetailsModel?.partialEncashmentDisburseDetailsModelList?.push(
                                  {
                                    partialAmount: '',
                                    partialEncashmentDate: '',
                                    remarks: ''
                                  }
                                );
                                setSelectedItemList([...prevArray]);
                              }}
                              placement="top"
                              arrow
                              sx={{ marginBottom: '4px' }}
                            >
                              <IconButton className="squareIconButton">
                                <MdOutlineAdd size={18} />
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <Tooltip
                              title="Remove"
                              onClick={() => {
                                const prevArray = selectedItemList;
                                prevArray[
                                  openAppointment.indexVal
                                ]?.encashmentDisburseDetailsModel?.partialEncashmentDisburseDetailsModelList?.splice(
                                  addItemIndex,
                                  1
                                );
                                setSelectedItemList([...prevArray]);
                              }}
                              placement="top"
                              arrow
                              sx={{ marginBottom: '4px' }}
                            >
                              <IconButton className="squareIconButton">
                                <AiOutlineMinus size={18} />
                              </IconButton>
                            </Tooltip>
                          )}
                        </Grid>
                      </Grid>
                    )
                  )
                : ''}
              <Button
                variant="contained"
                className="mainBtn mainBtnSec mainBtnOther mb-2"
                component="label"
              >
                Upload supporting document
                <input
                  hidden
                  accept="image/png, image/gif, image/jpeg, image/jpg"
                  type="file"
                  onChange={(e) => {
                    const fileData = e.target.files[0];
                    if (fileData !== undefined) {
                      uploadFileApiFire(
                        'fileUpload',
                        fileData,
                        'encashment',
                        selectedItemList[openAppointment.indexVal].applicationId
                      );
                    }
                  }}
                />
              </Button>
              <Box className="">
                <Typography variant="body2" mb={0.5}>
                  <strong>List of document uploaded</strong>
                </Typography>
                {selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                  ?.encashmentDisburseDocumentsDetailsModels.length > 0 ? (
                  selectedItemList[
                    openAppointment.indexVal
                  ]?.encashmentDisburseDetailsModel?.encashmentDisburseDocumentsDetailsModels.map(
                    (fileTtem, fileTtemIndex) => (
                      <Typography key={fileTtemIndex} variant="body2">
                        <span style={{ width: '100%', float: 'left' }}>
                          <span style={{ float: 'left', paddingRight: '5px' }}>
                            {fileTtem.fileName}
                          </span>{' '}
                          <CancelIcon
                            style={{
                              marginTop: '3px',
                              float: 'left',
                              fontSize: '15px',
                              cursor: 'pointer'
                            }}
                            onClick={() => {
                              const prevArray = selectedItemList;
                              prevArray[
                                openAppointment.indexVal
                              ].encashmentDisburseDetailsModel.encashmentDisburseDocumentsDetailsModels.splice(
                                fileTtemIndex,
                                1
                              );
                              setSelectedItemList([...prevArray]);
                            }}
                          />
                        </span>
                      </Typography>
                    )
                  )
                ) : (
                  <Typography variant="body2">No Document Uploaded</Typography>
                )}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  handleAppointmentSubmit(e, openAppointment.indexVal);
                }}
                variant="contained"
                className="mainBtn"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <ApiErrorMessage
            openApiError={openApiError}
            setOpenApiError={setOpenApiError}
            errorMessage={errorMessage}
          />
          <Loader openLoader={openLoader} />
          <Dialog
            open={dialogOpen}
            onClose={(e) => setDialogOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">{validationMsg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={(e) => setDialogOpen(false)}>Retry</Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
}
export default UpdateDisburse;
